export default __webpack_public_path__ + "static/media/DSC00393.c11862ae.JPG";